import { useCallback, useState } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useCvOverview } from './useCvOverview';
import { countCoverLetters } from '../services/coverLetter';

export interface CarriereApercu {
  /** Dernier score ATS, ou null tant qu'aucun CV n'a été noté. */
  score: number | null;
  /** Première correction suggérée au dernier score, s'il y en a une. */
  conseil: string | null;
  nbConseils: number;
  /** null tant que le comptage n'est pas revenu (ou s'il a échoué). */
  cvCount: number | null;
  lettres: number | null;
}

/**
 * Données vivantes de la page Carrière sur grand écran : de quoi dire où la personne en est, pas
 * seulement où aller. Utilisé par le gabarit large uniquement, le téléphone n'affiche pas d'état.
 *
 * Les lettres se recomptent à chaque retour sur l'écran (on revient souvent d'en avoir écrit une) ;
 * un échec laisse `null`, que l'écran affiche comme « pas encore chargé » et non comme zéro.
 */
export function useCarriereApercu(): CarriereApercu {
  const { lastScore, cvCount } = useCvOverview();
  const [lettres, setLettres] = useState<number | null>(null);

  useFocusEffect(
    useCallback(() => {
      let actif = true;
      countCoverLetters()
        .then((n) => actif && setLettres(n))
        .catch(() => actif && setLettres(null));
      return () => {
        actif = false;
      };
    }, []),
  );

  return {
    score: lastScore?.ats_score ?? null,
    conseil: lastScore?.advice?.[0] ?? null,
    nbConseils: lastScore?.advice?.length ?? 0,
    cvCount,
    lettres,
  };
}
